export enum ComposableDeviceUserInterfaces {
  OVEN = 'ST_OVEN',
  FRYER = 'ST_FRYER',
  SCC_MERCHANDISE = 'SCC_MERCHANDISE',
  SCC_MERCHANDISE_V2 = 'SCC_MERCHANDISE_V2',
  FLEXESERVE_AIRCONNECT = 'FLEXESERVE_CBOX_AIRCONNECT',
  FLEXESERVE_UI_HUB = 'FLEXESERVE_UI_HUB',
  FLEXESERVE_UI_SHELLY = 'FLEXESERVE_UI_SHELLY',
  FR_OVEN = 'FR_OVEN',
}

export const ST_COMPOSABLE_CONSUMPTION_DATA_KEY =
  'ST_COMPOSABLE_CONSUMPTION_DATA_KEY';

export const ST_KILO_WATT_EUR_CONSUMPTION_KEY = 'ST_KILO_WATT_EUR_CONSUMPTION';
